import { useState } from "react"

export const Setup = () => {
	const [anchorOffer, setAnchorOffer] = useState(null)
    const [prdctModalForm, setPrdctModalForm] = useState({
        toggled: false,
        id: "",
    });
    const [switches, setSwitches] = useState({
        variationSwitch: false,
        listShippingSwtch: 1,
        enableImgSwtch: true,
    })
    const [addProductForm, setAddProductForm] = useState({
        images: [],
    })
    // training
    const [trainingForm, setTrainingForm] = useState({open: false, code: '', id: '', training_name: '', training_type: '', training_date: '', training_start: '', training_end: '', location: '', training_fee: 'free', training_price: '', meeting_link: '', meeting_id: '', meeting_pass: '', confirmation: false, error: false, loader: false, method: 'create', active: true, show_shop: false})
    const dfltForm = [
        {open: false, code: '', id: '', training_name: '', training_type: '', training_date: '', training_start: '', training_end: '', location: '', training_fee: 'free', training_price: '', meeting_link: '', meeting_id: '', meeting_pass: '', confirmation: false, error: false, loader: false, method: 'create', active: true, show_shop: false}
    ]
    const [trainingList, setTrainingList] = useState([])
    const [totalList, setTotalList] = useState(0)
    const [loader, setLoader] = useState(false)
    const [page, setPage] = useState(1)
    const [hasMore, setHasMore] = useState(true)
	const [paymentInfo, setPaymentInfo] = useState([
		{ training_fee_id: '', training_fee_type_id: '', name: '', regularPrice: '', voucherCode: '', discount: '', price: 0 , voucherEnabled: false, loader: false, requiredPRC: false, showInShop: false, active: 1, temp_id: crypto.randomUUID() }
	])
	const dfltPaymentInfo = { training_fee_id: '', training_fee_type_id: '', name: '', regularPrice: '', voucherCode: '', discount: '', price: 0 , voucherEnabled: false, loader: false, requiredPRC: false, showInShop: false, active: 1, temp_id: crypto.randomUUID() }
	// membership
	const [memberForm, setMemberForm] = useState({
		code: '', 
		name: '',
		membershipFee: 'free',
		regularPrice: 0,
		discount: 0,
		price: 0,
		hasVoucherCode: false,
		voucherCode: '',
		inclusions: [{id: '', value: '', remove: false}],
		membershipValidity: 0,
		exclusive: true,
		hasTransaction: false,
	})
    const dfltMemberForm = {
		code: '', 
		name: '',
		membershipFee: 'free',
		regularPrice: 0,
		discount: 0,
		price: 0,
		hasVoucherCode: false,
		voucherCode: '',
		inclusions: [{id: '', value: '', remove: false}],
		membershipValidity: 0, 
		exclusive: true,
		hasTransaction: false,
	}
    const [memberList, setMemberList] = useState([])
    const [memberTotalList, setMemberTotalList] = useState(0)
    const [memberLoader, setMemberLoader] = useState({ list: false, statusSaving: false, viewForm: false, formSaving: false })
    const [memberPage, setMemberPage] = useState(1)
    const [memberHasMore, setMemberHasMore] = useState(true)
	const [memberModals, setMemberModals] = useState({ form: false, confirmation: false })
	const [memberSelected, setMemberSelected] = useState({ id: '', active: false })
	const [memberMethod, setMemberMethod] = useState('')
	const [memberError, setMemberError] = useState(false)

    return {
        anchorOffer: {data: anchorOffer, set: setAnchorOffer},
		prdctModalForm: {data: prdctModalForm, set: setPrdctModalForm},
        switches: {data: switches, set: setSwitches},
        addProductForm: {data: addProductForm, set: setAddProductForm},
        trainingForm: {data: trainingForm, set: setTrainingForm},
        dfltForm: {data: dfltForm},
        trainingList: {data: trainingList, set: setTrainingList},
        totalList: {data: totalList, set: setTotalList},
        loader: {data: loader, set: setLoader},
        page: {data: page, set: setPage},
        hasMore: {data: hasMore, set: setHasMore},
		paymentInfo: {data: paymentInfo, set: setPaymentInfo},
		dfltPaymentInfo: {data: dfltPaymentInfo},
		// membership
		memberForm: {data: memberForm, set: setMemberForm},
        dfltMemberForm: {data: dfltMemberForm},
        memberList: {data: memberList, set: setMemberList},
        memberTotalList: {data: memberTotalList, set: setMemberTotalList},
        memberLoader: {data: memberLoader, set: setMemberLoader},
        memberPage: {data: memberPage, set: setMemberPage},
        memberHasMore: {data: memberHasMore, set: setMemberHasMore},
		memberModals: {data: memberModals, set: setMemberModals},
		memberSelected: {data: memberSelected, set: setMemberSelected},
		memberMethod: {data: memberMethod, set: setMemberMethod},
		memberError: {data: memberError, set: setMemberError},
    }
}